module.exports = __webpack_public_path__ + "Typedepot---CentraleSansBook.54439eef4bb60b9d99a8.otf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/Typedepot---CentraleSansBook.otf
// module id = ../../../../../src/assets/fonts/Typedepot---CentraleSansBook.otf
// module chunks = styles